import { ChangeDetectorRef, Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { Apollo } from 'apollo-angular';
import 'brace';
import 'brace/mode/json';
import 'brace/mode/text';
import 'brace/theme/github';
import { Buffer } from 'buffer';
import { FilterMetadata } from 'primeng/api';
import { TableLazyLoadEvent } from 'primeng/table';
import { NXDataSourcePrime } from '../../services/dataSource/NXDataSourcePrime';
import { LoadingService } from '../../services/loading.service';
import { HttpLogsDataSource } from './httpLogsDataSource';

@Component({
  selector: 'app-http-logs',
  templateUrl: './http-logs.component.html',
  styleUrls: ['./http-logs.component.scss']
})
export class HttpLogsComponent implements OnInit, OnDestroy{

  public sortProperty: string;
  public defaultSortProperty: string = 'startDateTime';
  public sortDirection: string;
  public defaultSortDirection: string = 'desc';
  public pageNumber = 0;
  public pageSize = 15;
  public sortModel = { label: 'Start absteigend', fieldName: 'startDateTime', direction: "desc"};
  public sortOptions = [
    { label: 'Start absteigend', fieldName: 'startDateTime', direction: "desc"},
    { label: 'Start aufsteigend', fieldName: 'startDateTime', direction: "asc"}
  ];

  public dataSource: HttpLogsDataSource;
  public loading = false;

  // ace config so that it only takes the hight of the content
  editorConfig = {
    maxLines: Infinity,
    highlightActiveLine: false,
    highlightGutterLine: false,
    showPrintMargin: false,
  }

  public text: string;
  public statusCode: number; // currently not used, only text search is available

  constructor(
    private apollo: Apollo,
    private loadingService: LoadingService,
    @Inject('env') public environment: any,
    private cdRef: ChangeDetectorRef
  ) {
  }

  ngOnInit():void {
    this.dataSource = new HttpLogsDataSource(this.apollo, this.environment);
    this.dataSource.loading.subscribe((loading) => {
      this.loading = loading;
    });
    this.dataSource.loadHttpLogs({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      text: this.text ? this.text : '',
      statusCode: this.statusCode ? this.statusCode : null
    });
  }

  refetchHttpLogs(): void {
    this.dataSource.loadHttpLogs({
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      sortProperty: this.sortProperty ? this.sortProperty : this.defaultSortProperty,
      sortDirection: this.sortDirection ? this.sortDirection : this.defaultSortDirection,
      text: this.text ? this.text : '',
      statusCode: this.statusCode ? this.statusCode : null
    });
  }

  ngOnDestroy(): void {
    this.dataSource.disconnect();
  }

  loadData(event: TableLazyLoadEvent) {
    console.log(event);
    this.loading = true;

    // sorting
    if (event?.sortField !== undefined && typeof event?.sortField == 'string') {
      this.sortProperty = event.sortField;
    }
    if (event?.sortOrder !== undefined) {
      this.sortDirection = event.sortOrder === 1 ? 'asc' : 'desc';
    }

    //filtering
    this.text = event.globalFilter as string;
    // if (event?.filters.statusCode !== undefined) { // currently not used, only text search is available
      this.statusCode = (event.filters.statusCode as FilterMetadata)?.value;
    // }

     // pagination
     this.pageNumber = event?.first !== undefined ? event.first / event.rows : 0;
     this.pageSize = event?.rows !== undefined ? event.rows : 15;

     this.refetchHttpLogs();
   }

  sort(event: any) {
    if(event?.value?.direction && event?.value?.fieldName){
      this.sortProperty = event.value.fieldName;
      this.sortDirection = event.value.direction;
    } else {
      this.sortProperty = this.defaultSortProperty;
      this.sortDirection = this.defaultSortDirection;
    }
    this.cdRef.detectChanges();
  }

  translateSortDirectionToSortOrder(sortDirection: string): number {
    return NXDataSourcePrime.translateSortDirectionToSortOrder(sortDirection);
  }


  getJSON(base64: string) {
    if (base64 && base64?.length > 0) {
      let decodedData = Buffer.from(base64, 'base64').toString();
      let jsonData = JSON.parse(decodedData);
      return jsonData;
    }
    return '_';
  }

  getString(base64: string) {
    if (base64 && base64?.length > 0) {
      let stringData = Buffer.from(base64, 'base64').toString();
      return stringData;
    }
    return '_';
  }

  isJsonString(str: string): boolean {
    try {
      this.getJSON(str);
    } catch (e) {
      return false;
    }
    return true;
  }

  copyToClipboard(stringToCopy: string): void {
    navigator.clipboard.writeText(stringToCopy);
  }

  copyRequestContent(requestContent: string) {
    let base64 = requestContent;
    if (base64 && base64?.length > 0) {
      let string = Buffer.from(base64, 'base64').toString();
      let toCopy = this.isJsonString(string) ? JSON.stringify(JSON.parse(string)) : string;
      this.copyToClipboard(toCopy);
    }
  }

  getCodeModel(value: string) {
    try {
      if (value && value?.length > 0) {
        const decodedData = Buffer.from(value, 'base64').toString('utf-8');
        const jsonData = JSON.parse(decodedData);
        return JSON.stringify(jsonData, null, 2);
      }
      else {
        return "";
      }
    }
    catch (error) {
      console.error('Error decoding or parsing Base64 JSON:', error);
      return  "";
    }
  }

  calculateSeverity(statusCode: number) {
    if (statusCode >= 400) {
      return 'danger';
    }
    return 'success';
  }
}
